import { useQuery } from '@tanstack/react-query';
import { ISelectorsData } from 'models/timeForm/timeForm.model';
import api from 'services/api/api';
import { getWorkingDays } from 'services/api/requests/capacity/workingDays/workingDays';
import { getStopTypology } from 'services/api/requests/production';

export const getSelectorsData = async ({
	queryKey,
}): Promise<ISelectorsData> => {
	const [, productId, activityId, recursoId, data] = queryKey;

	const response = await api.get(`/horaHora/dadosLancamento`, {
		params: {
			...(productId ? { produto_id: productId } : null),
			...(activityId ? { atividade_roteiro_id: activityId } : null),
			...(recursoId ? { recurso_id: recursoId } : null),
			...(data ? { data } : null),
		},
	});

	const dataAtual = new Date();
	const anoAtual = dataAtual.getFullYear();

	if (!response.data.anos.length) {
		response.data.anos.push({ ano: anoAtual });
	}

	return response.data;
};

export const useSelectorsDataList = (
	productId?,
	activityId?,
	recursoId?,
	data?
) => {
	return useQuery(
		['selectors-data-list', productId, activityId, recursoId, data],
		getSelectorsData,
		{
			refetchOnWindowFocus: false,
		}
	);
};

export const useTypologyList = () => {
	return useQuery(['typology-list'], getStopTypology, {
		refetchOnWindowFocus: false,
	});
};

export const useWorkingDaysByYear = (year: string) => {
	return useQuery(['working-days-by-year', year], getWorkingDays, {
		refetchOnWindowFocus: false,
	});
};
